export enum AccountGroupType {
  POOL = 'POOL',
  PROGRAM = 'PROGRAM',
  TIER = 'TIER',
  BAND = 'BAND',
}

export interface BandDto {
  id: string;
  name: string;
  description: string;
  totalPremium?: number;
}

export interface TierDto {
  id: string;
  name: string;
  description: string;
  totalPremium?: number;
  bands?: BandDto[];
}

export interface AccountGroupResponseDto {
  id: string;
  name: string;
  description: string;
  groupType: AccountGroupType;
  parentGroupId?: string;
  parentGroupName?: string;
  /** Root POOL of the group's hierarchy; absent when the group is not rooted at a POOL (e.g. PROGRAM). */
  rootPoolId?: string;
  rootPoolName?: string;
  primaryAccountId?: string;
  created: string;
  modified: string;
  tiers?: TierDto[];
}

export interface CreatePoolBandDto {
  name: string;
  description: string;
  totalPremium: number;
  groupType: AccountGroupType.BAND;
}

export interface CreatePoolTierDto {
  name: string;
  description: string;
  groupType: AccountGroupType.TIER;
  totalPremium?: number;
  bands: CreatePoolBandDto[];
}

export interface CreateAccountGroupDto {
  name: string;
  description: string;
  productKey: string;
  groupType: AccountGroupType.POOL;
  tiers: CreatePoolTierDto[];
}
